import React from 'react'

import Error404 from 'components/Error404'
import MainLayout from 'components/Layout/Main'

const Page404 = () => <Error404 />
Page404.Layout = MainLayout
export default Page404
